import { useNavigate } from "react-router-dom";
import { toAbsoluteUrl } from "../../helpers";
import { useAuth } from "../../../app/modules/auth";
import { envConfig } from "../../../utils/config";

interface WidgetData {
    id: number;
    title: string;
    imageUrl: string;
    path?: string;
    externalUrl?: string;
    popup?: boolean;
    query?: any;
}


const WidgetBar = () => {
    const navigate = useNavigate();
    const { auth } = useAuth()
    const handleWidgetClick = ({
        path,
        externalUrl,
    }: WidgetData) => {
        if (path) {
            navigate(path);
            return;
        }

        if (externalUrl) {
            window.open(
                externalUrl,
                "_blank",
                "noopener,noreferrer"
            );
        }
    };

    const WIDGETS: WidgetData[] = [
        {
            id: 1,
            title: "Project Evaluation",
            imageUrl: "media/images/project-evoluation.png",
            path: "/dashboard/evaluation",
        },
        {
            id: 2,
            title: "Investor Ready Portfolio",
            imageUrl: "media/images/investment.png",
            path: "/dashboard/prospectus",
        },
        {
            id: 3,
            title: "Governance Tools & Methods",
            imageUrl: "media/images/governance-resources.png",
            path: "/dashboard/stagegates",
        },
        {
            id: 4,
            title: "Critical Gigamap",
            imageUrl: "media/images/certificate.png",
            externalUrl: auth ? envConfig.APP_GIGAMAP_URL : undefined,
            path: auth ? undefined : "/auth/login",
        },
        {
            id: 5,
            title: "EVE",
            imageUrl: "media/images/DOIplatformInfrabotwhite.png",
            popup: true,
            query: () => {
                const chatButton = document.querySelector(
                    ".chat-button"
                ) as HTMLElement | null;

                chatButton?.dispatchEvent(
                    new MouseEvent("click", {
                        bubbles: true,
                        cancelable: true,
                        view: window,
                    })
                );
            },

        }
    ];


    return (
        <div className="widgetbar-wrapper ps-2 py-2 rounded-start-4 d-none d-xl-block">
            <div className="widgetbar p-3 d-flex flex-column gap-3 pe-1 rounded-start-4 shadow-lg">
                {WIDGETS.map((widget) => (
                    <button
                        key={widget.id}
                        type="button"
                        className="widgetbar-item border-0 bg-transparent p-0"
                        onClick={() => { widget.popup ? widget.query?.() : handleWidgetClick(widget) }}
                        aria-label={widget.title}
                        title={widget.title}
                    >
                        <img
                            src={toAbsoluteUrl(widget.imageUrl)}
                            alt={widget.title}
                            className="w-50px"
                            loading="lazy"
                        />
                    </button>
                ))}
            </div>
        </div>
    );
};

export default WidgetBar;